import { RequestStatus } from '../../data/constants';
import {
  getCourseDetails,
  getCourseSettings,
  getIblCourseSettings,
  updateIblCourseSettings,
  copyIblCourseMetadata,
} from './api';
import {
  updateSavingStatus,
  updateLoadingDetailsStatus,
  updateLoadingSettingsStatus,
  updateLoadingIblStatus,
  fetchCourseDetailsSuccess,
  updateCourseDetailsSuccess,
  fetchCourseSettingsSuccess,
  fetchIblCourseSettingsSuccess,
  updateIblCourseSettingsSuccess,
} from './slice';

export function fetchCourseDetailsQuery(courseId) {
  return async (dispatch) => {
    dispatch(updateLoadingDetailsStatus({ status: RequestStatus.IN_PROGRESS }));

    try {
      const detailsValues = await getCourseDetails(courseId);
      dispatch(fetchCourseDetailsSuccess(detailsValues));
      dispatch(updateLoadingDetailsStatus({ status: RequestStatus.SUCCESSFUL }));
    } catch (error) {
      if (error.response && error.response.status === 403) {
        dispatch(updateLoadingDetailsStatus({ courseId, status: RequestStatus.DENIED }));
      } else {
        dispatch(updateLoadingDetailsStatus({ status: RequestStatus.FAILED }));
      }
    }
  };
}

export function fetchCourseSettingsQuery(courseId) {
  return async (dispatch) => {
    dispatch(updateLoadingSettingsStatus({ status: RequestStatus.IN_PROGRESS }));

    try {
      const settingsValues = await getCourseSettings(courseId);
      dispatch(fetchCourseSettingsSuccess(settingsValues));
      dispatch(updateLoadingSettingsStatus({ status: RequestStatus.SUCCESSFUL }));
      return true;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        dispatch(updateLoadingSettingsStatus({ courseId, status: RequestStatus.DENIED }));
      } else {
        dispatch(updateLoadingSettingsStatus({ status: RequestStatus.FAILED }));
      }
      return false;
    }
  };
}

/**
 * Fetch IBL course settings — primary source for all editable S&D fields.
 * Merges formData into courseDetails and stores formChoices in iblFormChoices.
 */
export function fetchIblCourseSettingsQuery(courseId) {
  return async (dispatch) => {
    dispatch(updateLoadingIblStatus({ status: RequestStatus.IN_PROGRESS }));

    try {
      const { formData, formChoices } = await getIblCourseSettings(courseId);
      dispatch(fetchIblCourseSettingsSuccess({ formData, formChoices }));
      dispatch(updateLoadingIblStatus({ status: RequestStatus.SUCCESSFUL }));
    } catch (error) {
      if (error.response && error.response.status === 403) {
        dispatch(updateLoadingIblStatus({ status: RequestStatus.DENIED }));
      } else {
        dispatch(updateLoadingIblStatus({ status: RequestStatus.FAILED }));
      }
    }
  };
}

/**
 * Save all course settings via the IBL endpoint.
 * Replaces the former updateCourseDetailsQuery (contentstore PUT).
 */
export function updateIblCourseSettingsQuery(courseId, details) {
  return async (dispatch) => {
    dispatch(updateSavingStatus({ status: RequestStatus.IN_PROGRESS }));

    try {
      const responseData = await updateIblCourseSettings(courseId, details);
      dispatch(updateIblCourseSettingsSuccess(responseData));
      dispatch(updateSavingStatus({ status: RequestStatus.SUCCESSFUL }));
      return true;
    } catch (error) {
      dispatch(updateSavingStatus({ status: RequestStatus.FAILED }));
      return false;
    }
  };
}

/**
 * Copy all metadata from a source course into the current course.
 * Self-contained — does not touch Redux state. Used by MetadataCopySection only.
 */
export function copyIblCourseMetadataQuery(sourceCourseId, targetCourseId) {
  return async () => {
    try {
      const result = await copyIblCourseMetadata(sourceCourseId, targetCourseId);
      return result;
    } catch (error) {
      return { error: error.message };
    }
  };
}

// Re-export for backwards compatibility with any existing call sites outside S&D.
export { updateCourseDetailsSuccess };
